import {isValidUUID} from '@sollapay/domain/rules';

/** Where a guest lands after signing in: the invited account when the link names a valid one, else their list. */
export function resolveGuestReturnTo(accountId: string | null): string {
  return accountId && isValidUUID(accountId) ? `/trust-accounts/${accountId}` : '/trust-accounts';
}
